import { EmployeeManPowerOverlapping } from './EmployeeManPowerOverlapping';
import { EmployeeOrProspect } from './EmployeeOrProspect';

export class OverLappingJobAndEmployeeOrProspect {
  OverlappingManPower: EmployeeManPowerOverlapping[];
  Person: EmployeeOrProspect;
}
